// Configuration for SmartGTD WebApp Frontend
// Fetches dynamic config from backend at runtime

let configCache = null;
let configPromise = null;

/**
 * Fetch configuration from backend API
 * Config includes Cognito URLs and API endpoints
 * Cached globally to prevent multiple fetches
 */
export async function fetchConfig() {
  // Return cached config if available
  if (configCache) {
    return configCache;
  }
  
  // Return existing promise if fetch is in progress
  if (configPromise) {
    return configPromise;
  }
  
  // Start new fetch
  const url = process.env.NODE_ENV === 'production' 
    ? `https://api.${window.location.hostname.replace('webapp.', '')}/config`
    : 'http://localhost:8000/config';
  
  configPromise = fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Config fetch failed: ${response.status}`);
      }
      return response.json();
    })
    .then(config => {
      configCache = config;
      configPromise = null;
      return config;
    })
    .catch(error => {
      configPromise = null;
      throw error;
    });
  
  return configPromise;
}

export default {};
